import { render, staticRenderFns } from "./QuangCaoList.vue?vue&type=template&id=3fb747f9&scoped=true&"
import script from "./QuangCaoList.vue?vue&type=script&lang=js&"
export * from "./QuangCaoList.vue?vue&type=script&lang=js&"
import style0 from "./QuangCaoList.vue?vue&type=style&index=0&id=3fb747f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb747f9",
  null
  
)

export default component.exports